<template>
  <div class="myInvoiceBox">
    <!-- 标题box -->
    <div class="myInvoiceBox_title">{{ title }}</div>
    <!-- 主体box -->
    <div class="myInvoiceBox_main">
      <!-- 顶部导航栏 -->
      <div class="mainBox_nav">
        <div class="mainBox_navL">
          <div
            :class="['mainBox_navList', index == chooseIndex ? 'active' : '']"
            v-for="(item, index) in navList"
            :key="index"
            @click="changeNav(index)"
          >
            {{ item }}
          </div>
        </div>
        <div
          class="mainBox_navR"
          @click="showDialog()"
          v-if="invoiceInfoList.length > 0"
        >
          <img
            class="mainBox_navRImg"
            src="/static/image/addInvoice.png"
            alt=""
          />
          <div class="mainBox_navRText">新增抬头</div>
        </div>
      </div>
      <div class="mainBox_infoCard" v-if="invoiceInfoList.length > 0">
        <div class="mainBox_infoCardL">
          <div class="mainBox_infoCardTitle">
            {{ invoiceInfoList[0].companyName }}
          </div>
          <div class="mainBox_infoCardList">
            <span>发票类型：</span
            ><span>{{
              invoiceInfoList[0].invoiceType == 0
                ? "增值税普通发票"
                : "增值税专用发票"
            }}</span>
          </div>
          <div class="mainBox_infoCardList">
            <span>税号：</span><span>{{ invoiceInfoList[0].taxesNumber }}</span>
          </div>
          <!-- <div class="mainBox_infoCardList">
            <span>单位地址：</span><span>{{ invoiceInfoList[0].registAdress }}</span>
          </div>
          <div class="mainBox_infoCardList">
            <span>电话：</span><span>{{ invoiceInfoList[0].registPhone }}</span>
          </div>
          <div class="mainBox_infoCardList">
            <span>开户银行：</span><span>{{ invoiceInfoList[0].openingBank }}</span>
          </div>
          <div class="mainBox_infoCardList">
            <span>银行账户：</span><span>{{ invoiceInfoList[0].bankAccount }}</span>
          </div>

          <div class="mainBox_infoCardList">
            <span>收货人姓名：</span><span>{{ invoiceInfoList[0].pickName }}</span>
          </div>
          <div class="mainBox_infoCardList">
            <span>收货人电话：</span><span>{{ invoiceInfoList[0].pickPhone }}</span>
          </div>
          <div class="mainBox_infoCardList">
            <span>寄送地址：</span><span>{{ invoiceInfoList[0].sendAddress }}</span>
          </div> -->
          <!-- <div class="mainBox_infoCardList">
            <span>电子邮箱：</span><span>{{ invoiceInfoList[0].email }}</span>
          </div> -->
        </div>
        <div class="mainBox_infoCardR">
          <el-button
            v-if="userInfo.selfInvoicing != 0"
            type="text"
            style="font-size: 13px; color: #000"
            @click="isShowList = true"
            v-preventReClick
            :disabled="false"
            >查看</el-button
          >
          <div class="line"></div>
          <el-button
            v-if="userInfo.selfInvoicing != 0"
            type="text"
            style="font-size: 13px"
            @click="editDialog(0)"
            v-preventReClick
            :disabled="false"
            >编辑</el-button
          >
        </div>
      </div>
      <el-empty
        v-else
        class="topEmpty"
        image="/static/image/noInvoice.png"
        description=" "
        :image-size="192"
      >
        <div class="empty_description">暂无发票信息</div>
        <el-button
          v-if="isShowAddBtn && userInfo.selfInvoicing != 0"
          type="primary"
          icon="el-icon-plus"
          style="width: 161px; height: 53px; margin-top: 43px"
          @click="showDialog()"
          >新增发票信息</el-button
        >
      </el-empty>
    </div>
    <div class="myInvoiceBox_main">
      <div class="orderList_title">开票记录</div>

      <div class="mainBox_titleBox">
        <div style="width: 348px">订单详情</div>
        <div style="width: 130px">发票类型</div>
        <div style="width: 196px">发票抬头</div>
        <div style="width: 130px">发票性质</div>
        <div style="width: 130px">状态</div>
        <div style="width: 140px">操作</div>
      </div>

      <el-empty
        description="暂无数据"
        v-if="invoiceList.length == 0"
      ></el-empty>

      <div
        class="mainBox_orderList"
        v-for="(item, index) in invoiceList"
        :key="index"
      >
        <div class="orderList_top">
          <span>{{ getDate(item.createTime) }}</span
          ><span>订单号：{{ item.ordersn }}</span>
        </div>
        <div class="orderList_main" v-if="item.orderGoods.length > 0">
          <img
            :src="item.orderGoods[0].goodsThumb"
            alt=""
            class="orderList_img"
            @click="gotoDetails(item.orderGoods[0].goodsId)"
          />
          <div class="orderList_mainTitle">
            <span style="margin-bottom: 10px">{{
              item.orderGoods[0].title
            }}</span>
            <span> x{{ item.orderGoods[0].total }}</span>
          </div>

          <span style="width: 130px" class="mainSpan">{{
            item.invoiceType == 0 ? "增值税普通发票" : "增值税专用发票"
          }}</span>
          <div style="width: 196px; text-align: center">
            {{ item.companyName }}
          </div>
          <div style="width: 130px">
            {{ item.acceptType == 0 ? "电子发票" : "纸质发票" }}
          </div>
          <div style="width: 130px">
            {{
              item.acceptType == 0
                ? item.status == 0
                  ? "开票失败"
                  : item.status == 1
                  ? "已开具"
                  : "开票中"
                : item.status == 1
                ? "已邮寄"
                : "开票中"
            }}
          </div>

          <div class="btnBox" @click.stop="nothing()">
            <el-link
              :underline="false"
              type="primary"
              style="font-size: 12px"
              @click.stop="gotoDetails2(item.id)"
              >发票详情</el-link
            >
          </div>
        </div>
      </div>

      <div class="pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="current"
          layout=" prev, pager, next,total, jumper"
          :total="total"
          :page-size="limit"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增发票信息弹窗 -->
    <el-dialog
      title="新增发票信息"
      :visible.sync="dialogVisible"
      width="767px"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="141px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="抬头类型："
          prop="headType"
          style="margin-bottom: 20px"
        >
          <el-radio-group v-model="ruleForm.headType">
            <el-radio
              @click.native.prevent="onRadioChange(item.value)"
              :label="item.value"
              v-for="(item, index) in headTypeList"
              :key="index"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="单位名称：" prop="companyName">
          <el-input
            v-model="ruleForm.companyName"
            placeholder="请输入单位名称"
            style="width: 460px"
          ></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别码：" prop="taxesNumber">
          <el-input
            v-model="ruleForm.taxesNumber"
            placeholder="请输入纳税人识别码"
            style="width: 460px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="默认发票类型："
          prop="invoiceType"
          style="margin-bottom: 20px"
        >
          <el-radio-group v-model="ruleForm.invoiceType">
            <el-radio
              @click="
                index == 1 && ruleForm.acceptType == 0
                  ? ''
                  : changeInvoiceType(index)
              "
              :label="index"
              v-for="(item, index) in ['增值税普通发票', '增值税专用发票']"
              :key="index"
              :disabled="index == 1 && ruleForm.acceptType == 0"
              >{{ item }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <!-- <el-form-item label="单位地址：" prop="area">
          <area-select
            v-if="isShowArea"
            v-model="ruleForm.area"
            :data="$pcaa"
            :level="3"
            style="display: flex; line-height: 18px"
            type="all"
          ></area-select>
        </el-form-item> -->
        <el-form-item label="单位地址：" prop="registAdress">
          <el-input
            v-model="ruleForm.registAdress"
            placeholder="请输入单位地址"
            style="width: 460px"
          ></el-input>
        </el-form-item>

        <el-form-item label="电话：" prop="registPhone">
          <el-input
            v-model="ruleForm.registPhone"
            placeholder="请输入电话"
            style="width: 460px"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户银行：" prop="openingBank">
          <el-input
            v-model="ruleForm.openingBank"
            placeholder="请输入开户银行"
            style="width: 460px"
          ></el-input>
        </el-form-item>
        <el-form-item label="银行账户：" prop="bankAccount">
          <el-input
            v-model="ruleForm.bankAccount"
            placeholder="请输入银行账户"
            style="width: 460px"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="寄送地址：" prop="area">
          <area-select
            v-if="isShowArea2"
            v-model="ruleForm.area"
            :data="$pcaa"
            :level="3"
            style="display: flex; line-height: 18px"
            type="all"
          ></area-select>
        </el-form-item> -->
        <el-form-item
          label="接收方式："
          prop="acceptType"
          style="margin-bottom: 20px"
        >
          <el-radio-group v-model="ruleForm.acceptType">
            <el-radio
              @click.native="changeAcceptType(index)"
              :label="index"
              v-for="(item, index) in ['电子发票']"
              :key="index"
              >{{ item }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <div style="color: #f89a00; margin: -15px 60px 20px">
          如需纸质发票，请联系客户经理
        </div>
        <el-form-item label="设为默认：" prop="idDefault">
          <el-switch v-model="ruleForm.isDefault"></el-switch>
        </el-form-item>
        <!-- <el-form-item
          label="收货人姓名："
          prop="pickName"
          v-if="ruleForm.acceptType == 1"
        >
          <el-input
            v-model="ruleForm.pickName"
            placeholder="请输入收货人姓名"
            style="width: 460px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="收货人电话："
          prop="pickPhone"
          v-if="ruleForm.acceptType == 1"
        >
          <el-input
            v-model="ruleForm.pickPhone"
            placeholder="请输入收货人电话"
            style="width: 460px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="寄送地址："
          prop="sendAddress"
          v-if="ruleForm.acceptType == 1"
        >
          <el-input
            v-model="ruleForm.sendAddress"
            placeholder="请输入寄送地址"
            style="width: 460px"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="电子邮箱：" prop="email">
          <el-input
            v-model="ruleForm.email"
            placeholder="请输入电子邮箱"
            style="width: 460px"
          ></el-input>
        </el-form-item> -->
        <!-- <el-checkbox v-model="isAgree" style="margin-left: 141px"
          >我已阅读并同意<span
            style="color: #F89A00; cursor: pointer"
            @click.prevent="dialogVisible = true"
            >《开票资质确认书》</span
          ></el-checkbox
        > -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <!-- 修改发票信息弹窗 -->
    <el-dialog
      title="编辑发票信息"
      :visible.sync="dialogVisible2"
      width="767px"
      :before-close="handleClose2"
    >
      <el-form
        :model="ruleForm2"
        :rules="rules2"
        ref="ruleForm2"
        label-width="141px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="抬头类型："
          prop="headType"
          style="margin-bottom: 20px"
        >
          <el-radio-group v-model="ruleForm2.headType">
            <el-radio
              @click.native.prevent="onRadioChange2(item.value)"
              :label="item.value"
              v-for="(item, index) in headTypeList"
              :key="index"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="单位名称：" prop="companyName">
          <el-input
            v-model="ruleForm2.companyName"
            placeholder="请输入单位名称"
            style="width: 460px"
          ></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别码：" prop="taxesNumber">
          <el-input
            v-model="ruleForm2.taxesNumber"
            placeholder="请输入纳税人识别码"
            style="width: 460px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="默认发票类型："
          prop="invoiceType"
          style="margin-bottom: 20px"
        >
          <el-radio-group v-model="ruleForm2.invoiceType">
            <el-radio
              @click="
                index == 1 && ruleForm2.acceptType == 0
                  ? ''
                  : changeInvoiceType2(index)
              "
              :label="index"
              v-for="(item, index) in ['增值税普通发票', '增值税专用发票']"
              :key="index"
              :disabled="index == 1 && ruleForm2.acceptType == 0"
              >{{ item }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <!-- <el-form-item label="单位地址：" prop="area">
          <area-select
            v-model="ruleForm2.area"
            :data="$pcaa"
            :level="3"
            style="display: flex; line-height: 18px"
            type="all"
          ></area-select>
        </el-form-item> -->
        <el-form-item label="单位地址：" prop="registAdress">
          <el-input
            v-model="ruleForm2.registAdress"
            placeholder="请输入单位地址"
            style="width: 460px"
          ></el-input>
        </el-form-item>

        <el-form-item label="电话：" prop="registPhone">
          <el-input
            v-model="ruleForm2.registPhone"
            placeholder="请输入电话"
            style="width: 460px"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户银行：" prop="openingBank">
          <el-input
            v-model="ruleForm2.openingBank"
            placeholder="请输入开户银行"
            style="width: 460px"
          ></el-input>
        </el-form-item>
        <el-form-item label="银行账户：" prop="bankAccount">
          <el-input
            v-model="ruleForm2.bankAccount"
            placeholder="请输入银行账户"
            style="width: 460px"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="寄送地址：" prop="area">
          <area-select
            v-model="ruleForm2.area"
            :data="$pcaa"
            :level="3"
            style="display: flex; line-height: 18px"
            type="all"
          ></area-select>
        </el-form-item> -->
        <el-form-item
          label="接收方式："
          prop="acceptType"
          style="margin-bottom: 20px"
        >
          <el-radio-group v-model="ruleForm2.acceptType">
            <el-radio
              @click.native="changeAcceptType2(index)"
              :label="index"
              v-for="(item, index) in ['电子发票']"
              :key="index"
              >{{ item }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <div style="color: #f89a00; margin: -15px 60px 20px">
          如需纸质发票，请联系客户经理
        </div>
        <el-form-item label="设为默认：" prop="isDefault">
          <el-switch v-model="ruleForm2.isDefault"></el-switch>
        </el-form-item>
        <!-- <el-form-item
          label="收货人姓名："
          prop="pickName"
          v-if="ruleForm2.acceptType == 1"
        >
          <el-input
            v-model="ruleForm2.pickName"
            placeholder="请输入收货人姓名"
            style="width: 460px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="收货人电话："
          prop="pickPhone"
          v-if="ruleForm2.acceptType == 1"
        >
          <el-input
            v-model="ruleForm2.pickPhone"
            placeholder="请输入收货人电话"
            style="width: 460px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="寄送地址："
          prop="sendAddress"
          v-if="ruleForm2.acceptType == 1"
        >
          <el-input
            v-model="ruleForm2.sendAddress"
            placeholder="请输入寄送地址"
            style="width: 460px"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="电子邮箱：" prop="email">
          <el-input
            v-model="ruleForm2.email"
            placeholder="请输入电子邮箱"
            style="width: 460px"
          ></el-input>
        </el-form-item> -->
        <!-- <el-checkbox v-model="isAgree2" style="margin-left: 141px"
          >我已阅读并同意<span
            style="color: #F89A00; cursor: pointer"
            @click.prevent="dialogVisible = true"
            >《开票资质确认书》</span
          ></el-checkbox
        > -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm2('ruleForm2')">取 消</el-button>
        <el-button type="primary" @click="submitForm2('ruleForm2')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <Dialog
      :isDefault="false"
      :dialogVisible="isShowList"
      @closepop="isShowList = false"
      width="1051px"
      class="dialogBox"
    >
      <div slot="content" style="width: 100%">
        <span class="dialogBox_title">查看抬头信息</span>
        <el-table
          :data="invoiceInfoList"
          :header-cell-style="{ background: '#e8e8e8', color: '#000' }"
          :header-row-style="{ background: '#e8e8e8', color: '#000' }"
          style="margin: 0 auto 28px; font-size: 14px"
          max-height="500"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="100px"
          />
          <el-table-column prop="invoiceType" label="抬头类型" align="left">
            <template slot-scope="scope">
              <span>{{
                scope.row.invoiceType == 0 ? "增值税普通发票" : "增值税专用发票"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="companyName" label="单位名称" align="left">
            <template slot-scope="scope">
              <span>{{ scope.row.companyName }}</span>
              <span class="defaultTag" v-if="scope.row.isDefault == 1"
                >默认</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="taxesNumber"
            label="纳税人识别号"
            align="left"
          />
          <el-table-column label="操作" width="200px" align="left">
            <template slot-scope="scope">
              <el-link :underline="false" @click="deleteInvoice(scope.row.id)"
                >删除</el-link
              >
              <div class="dialogBox_line"></div>
              <el-link
                type="primary"
                :underline="false"
                @click="editDialog(scope.$index)"
                >编辑</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </Dialog>
  </div>
</template>
<script>
import { doGet } from "../../common/HttpHelper.js";
import { httpConfig } from "../../common/config.js";
import dialog from "../../common/dialog.vue";

export default {
  props: {
    title: String,
    required: true,
  },
  components: {
    Dialog: dialog,
  },
  data() {
    return {
      phoneOrTelephone: (rule, value, callback) => {
        var reg = /^(0[0-9]{2,3}\-)([2-9][0-9]{4,7})+(\-[0-9]{1,4})?$/;
        var reg2 =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (value.length == 0 || reg.test(value) || reg2.test(value)) {
          callback();
        } else {
          callback(
            new Error("请输入正确的固定电话（例025-********）或者手机号")
          );
        }
      },
      isShowAddBtn: false, //新增按钮是否显示
      userInfo: this.$cookies.get("userInfo"),
      navList: ["发票信息及地址管理"], //顶部导航栏列表
      chooseIndex: 0, //选中的nav的索引

      invoiceInfoList: [], //发票信息列表
      headTypeList: [
        { label: "政府机关", value: 3 },
        { label: "事业单位", value: 2 },
        { label: "企业", value: 1 },
        // { label: "个人", value: 0 },
      ],

      current: 1, //当前页数
      total: 0, //总条数
      limit: 8, //每页显示几条

      invoiceList: [], //开票记录列表
      dialogVisible: false, //新增弹窗是否显示
      dialogVisible2: false, //编辑弹窗是否显示

      isShowArea: true, //用于销毁省市区组件
      isShowArea2: true,
      //新增发票信息表单
      ruleForm: {
        headType: 3,
        companyName: "",
        taxesNumber: "",
        invoiceType: 0,
        registAdress: "",
        registPhone: "",
        openingBank: "",
        bankAccount: "",

        acceptType: 0,
        pickName: "",
        pickPhone: "",
        sendAddress: "",
        isDefault: true,

        // email: "",
      },
      //新增发票信息表单验证
      rules: {
        headType: [
          // { required: true, message: "请选择抬头类型", trigger: "change" },
        ],
        companyName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        taxesNumber: [
          {
            pattern: /^[A-Za-z0-9]{10,20}$/,
            message: "只能输入10-20位 数字或26个英文字母",
            trigger: "change",
          },
        ],
        invoiceType: [
          { required: true, message: "请选择默认发票类型", trigger: "change" },
        ],
        registAdress: [],
        registPhone: [],
        openingBank: [],
        bankAccount: [],

        acceptType: [
          { required: true, message: "请选择接收方式", trigger: "change" },
        ],
        pickName: [],
        pickPhone: [],
        sendAddress: [],
        isDefault: [],
        // email: [
        //   // { required: true, message: "请输入电子邮箱", trigger: "blur" },
        //   {
        //     pattern: /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
        //     message: "请输入正确的邮箱",
        //     trigger: "blur",
        //   },
        // ],
      },
      isAgree: false, //新增发票信息时是否同意规则

      //修改发票信息表单
      ruleForm2: {
        headType: "",
        companyName: "",
        taxesNumber: "",
        invoiceType: 0,
        registAdress: "",
        registPhone: "",
        openingBank: "",
        bankAccount: "",
        acceptType: 0,
        pickName: "",
        pickPhone: "",
        sendAddress: "",
        isDefault: true,

        // email: "",
      },
      //修改发票信息表单验证
      rules2: {
        headType: [
          // { required: true, message: "请选择抬头类型", trigger: "change" },
        ],
        companyName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        taxesNumber: [
          {
            pattern: /^[A-Za-z0-9]{10,20}$/,
            message: "只能输入10-20位 数字或26个英文字母",
            trigger: "change",
          },
        ],
        invoiceType: [
          { required: true, message: "请选择默认发票类型", trigger: "change" },
        ],
        registAdress: [],
        registPhone: [],
        openingBank: [],
        bankAccount: [],

        acceptType: [
          { required: true, message: "请选择接收方式", trigger: "change" },
        ],
        pickName: [],
        pickPhone: [],
        sendAddress: [],
        isDefault: [],
        // email: [
        //   // { required: true, message: "请输入电子邮箱", trigger: "blur" },
        //   {
        //     pattern: /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
        //     message: "请输入正确的邮箱",
        //     trigger: "blur",
        //   },
        // ],
      },
      isAgree2: true, //修改发票信息时是否同意规则
      isShowList: false, //发票列表弹窗是否显示
    };
  },
  mounted() {
    this.judegRules();
    this.getList(1); //获取开票列表
    this.getInfo();
  },
  methods: {
    /**
     * 时间格式化（补0）
     */
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    /**
     * 时间戳转换
     */
    getDate(time) {
      if (!time) return "";
      if (time == typeof string) {
        var reg = getRegExp("-", "g"); // 获取正则表达式，全局替换
        time = time.replace(reg, "/");
      }
      var date = new Date(time);
      var M = date.getMonth() + 1;
      var y = date.getFullYear();
      var d = date.getDate();
      var h = date.getHours();
      var mm = date.getMinutes();
      var s = date.getSeconds();
      if (M < 10) M = "0" + M;
      if (d < 10) d = "0" + d;
      return (
        y +
        "." +
        M +
        "." +
        d +
        " " +
        this.add0(h) +
        ":" +
        this.add0(mm) +
        ":" +
        this.add0(s)
      );
    },
    judegRules() {
      this.rules.registAdress = [
        this.ruleForm.invoiceType == 1 || this.ruleForm.headType == 1
          ? { required: true, message: "请输入单位地址", trigger: "blur" }
          : "",
      ];
      this.rules.registPhone =
        this.ruleForm.invoiceType == 1 || this.ruleForm.headType == 1
          ? [
              { required: true, message: "请输入电话", trigger: "blur" },
              { validator: this.phoneOrTelephone, trigger: "blur" },
            ]
          : [{ validator: this.phoneOrTelephone, trigger: "blur" }];
      this.rules.openingBank = [
        this.ruleForm.invoiceType == 1 || this.ruleForm.headType == 1
          ? { required: true, message: "请输入开户银行", trigger: "blur" }
          : "",
      ];
      this.rules.bankAccount = [
        this.ruleForm.invoiceType == 1 || this.ruleForm.headType == 1
          ? { required: true, message: "请输入银行账户", trigger: "blur" }
          : "",
      ];
      this.rules.taxesNumber =
        this.ruleForm.invoiceType == 0 &&
        (this.ruleForm.headType == 2 || this.ruleForm.headType == 3)
          ? [
              {
                pattern: /^[A-Za-z0-9]{10,20}$/,
                message: "只能输入10-20位 数字或26个英文字母",
                trigger: "change",
              },
            ]
          : [
              {
                required: true,
                message: "请输入纳税人识别码",
                trigger: "blur",
              },
              {
                pattern: /^[A-Za-z0-9]{10,20}$/,
                message: "只能输入10-20位 数字或26个英文字母",
                trigger: "change",
              },
            ];

      this.rules2.registAdress = [
        this.ruleForm2.invoiceType == 1 || this.ruleForm2.headType == 1
          ? { required: true, message: "请输入单位地址", trigger: "blur" }
          : "",
      ];
      this.rules2.registPhone =
        this.ruleForm2.invoiceType == 1 || this.ruleForm2.headType == 1
          ? [
              { required: true, message: "请输入电话", trigger: "blur" },
              { validator: this.phoneOrTelephone, trigger: "blur" },
            ]
          : [{ validator: this.phoneOrTelephone, trigger: "blur" }];
      this.rules2.openingBank = [
        this.ruleForm2.invoiceType == 1 || this.ruleForm2.headType == 1
          ? { required: true, message: "请输入开户银行", trigger: "blur" }
          : "",
      ];
      this.rules2.bankAccount = [
        this.ruleForm2.invoiceType == 1 || this.ruleForm2.headType == 1
          ? { required: true, message: "请输入银行账户", trigger: "blur" }
          : "",
      ];
      this.rules2.taxesNumber =
        this.ruleForm2.invoiceType == 0 &&
        (this.ruleForm2.headType == 2 || this.ruleForm2.headType == 3)
          ? [
              {
                pattern: /^[A-Za-z0-9]{10,20}$/,
                message: "只能输入10-20位 数字或26个英文字母",
                trigger: "change",
              },
            ]
          : [
              {
                required: true,
                message: "请输入纳税人识别码",
                trigger: "blur",
              },
              {
                pattern: /^[A-Za-z0-9]{10,20}$/,
                message: "只能输入10-20位 数字或26个英文字母",
                trigger: "change",
              },
            ];
      // this.rules.pickName = [
      //   this.ruleForm.acceptType == 1
      //     ? { required: true, message: "请输入收货人姓名", trigger: "blur" }
      //     : "",
      // ];
      // this.rules.pickPhone =
      //   this.ruleForm.acceptType == 1
      //     ? [
      //         { required: true, message: "请输入收货人电话", trigger: "blur" },
      //         {
      //           pattern:
      //             /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
      //           message: "请输入正确的收货人电话",
      //           trigger: "blur",
      //         },
      //       ]
      //     : [
      //         {
      //           pattern:
      //             /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
      //           message: "请输入正确的收货人电话",
      //           trigger: "blur",
      //         },
      //       ];
      // this.rules.sendAddress = [
      //   this.ruleForm.acceptType == 1
      //     ? { required: true, message: "请输入寄送地址", trigger: "blur" }
      //     : "",
      // ];

      // this.rules2.pickName = [
      //   this.ruleForm2.acceptType == 1
      //     ? { required: true, message: "请输入收货人姓名", trigger: "blur" }
      //     : "",
      // ];
      // this.rules2.pickPhone =
      //   this.ruleForm2.acceptType == 1
      //     ? [
      //         { required: true, message: "请输入收货人电话", trigger: "blur" },
      //         {
      //           pattern:
      //             /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
      //           message: "请输入正确的收货人电话",
      //           trigger: "blur",
      //         },
      //       ]
      //     : [
      //         {
      //           pattern:
      //             /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
      //           message: "请输入正确的收货人电话",
      //           trigger: "blur",
      //         },
      //       ];
      // this.rules2.sendAddress = [
      //   this.ruleForm2.acceptType == 1
      //     ? { required: true, message: "请输入寄送地址", trigger: "blur" }
      //     : "",
      // ];
    },
    /**
     * 单选框二次点击取消选中
     */
    onRadioChange(e) {
      if (this.ruleForm.headType === e) {
        this.ruleForm.headType = "";
      } else {
        // 不是选中，选中当前点击 Radio
        this.ruleForm.headType = e;
        // 选中操作
      }
      this.rules.registAdress = [
        this.ruleForm.invoiceType == 1 || this.ruleForm.headType == 1
          ? { required: true, message: "请输入单位地址", trigger: "blur" }
          : "",
      ];
      this.rules.registPhone =
        this.ruleForm.invoiceType == 1 || this.ruleForm.headType == 1
          ? [
              { required: true, message: "请输入电话", trigger: "blur" },
              { validator: this.phoneOrTelephone, trigger: "blur" },
            ]
          : [{ validator: this.phoneOrTelephone, trigger: "blur" }];
      this.rules.openingBank = [
        this.ruleForm.invoiceType == 1 || this.ruleForm.headType == 1
          ? { required: true, message: "请输入开户银行", trigger: "blur" }
          : "",
      ];
      this.rules.bankAccount = [
        this.ruleForm.invoiceType == 1 || this.ruleForm.headType == 1
          ? { required: true, message: "请输入银行账户", trigger: "blur" }
          : "",
      ];

      this.rules.taxesNumber =
        this.ruleForm.invoiceType == 0 &&
        (this.ruleForm.headType == 2 ||
          this.ruleForm.headType == 3 ||
          this.ruleForm.headType == "")
          ? [
              {
                pattern: /^[A-Za-z0-9]{10,20}$/,
                message: "只能输入10-20位 数字或26个英文字母",
                trigger: "change",
              },
            ]
          : [
              {
                required: true,
                message: "请输入纳税人识别码",
                trigger: "blur",
              },
              {
                pattern: /^[A-Za-z0-9]{10,20}$/,
                message: "只能输入10-20位 数字或26个英文字母",
                trigger: "change",
              },
            ];
    },
    onRadioChange2(e) {
      if (this.ruleForm2.headType === e) {
        this.ruleForm2.headType = "";
      } else {
        // 不是选中，选中当前点击 Radio
        // 选中操作
        this.ruleForm2.headType = e;
      }
      this.rules2.registAdress = [
        this.ruleForm2.invoiceType == 1 || this.ruleForm2.headType == 1
          ? { required: true, message: "请输入单位地址", trigger: "blur" }
          : "",
      ];
      this.rules2.registPhone =
        this.ruleForm2.invoiceType == 1 || this.ruleForm2.headType == 1
          ? [
              { required: true, message: "请输入电话", trigger: "blur" },
              { validator: this.phoneOrTelephone, trigger: "blur" },
            ]
          : [{ validator: this.phoneOrTelephone, trigger: "blur" }];
      this.rules2.openingBank = [
        this.ruleForm2.invoiceType == 1 || this.ruleForm2.headType == 1
          ? { required: true, message: "请输入开户银行", trigger: "blur" }
          : "",
      ];
      this.rules2.bankAccount = [
        this.ruleForm2.invoiceType == 1 || this.ruleForm2.headType == 1
          ? { required: true, message: "请输入银行账户", trigger: "blur" }
          : "",
      ];
      this.rules2.taxesNumber =
        this.ruleForm2.invoiceType == 0 &&
        (this.ruleForm2.headType == 2 ||
          this.ruleForm2.headType == 3 ||
          this.ruleForm2.headType == "")
          ? [
              {
                pattern: /^[A-Za-z0-9]{10,20}$/,
                message: "只能输入10-20位 数字或26个英文字母",
                trigger: "change",
              },
            ]
          : [
              {
                required: true,
                message: "请输入纳税人识别码",
                trigger: "blur",
              },
              {
                pattern: /^[A-Za-z0-9]{10,20}$/,
                message: "只能输入10-20位 数字或26个英文字母",
                trigger: "change",
              },
            ];
    },
    /**
     * 选择发票类型
     */
    changeInvoiceType(index) {
      this.rules.registAdress = [
        index == 1
          ? { required: true, message: "请输入单位地址", trigger: "blur" }
          : "",
      ];
      this.rules.registPhone =
        index == 1
          ? [
              { required: true, message: "请输入电话", trigger: "blur" },
              { validator: this.phoneOrTelephone, trigger: "blur" },
            ]
          : [{ validator: this.phoneOrTelephone, trigger: "blur" }];
      this.rules.openingBank = [
        index == 1
          ? { required: true, message: "请输入开户银行", trigger: "blur" }
          : "",
      ];
      this.rules.bankAccount = [
        index == 1
          ? { required: true, message: "请输入银行账户", trigger: "blur" }
          : "",
      ];
      this.rules.taxesNumber =
        index == 0 &&
        (this.ruleForm.headType == 2 || this.ruleForm.headType == 3)
          ? [
              {
                pattern: /^[A-Za-z0-9]{10,20}$/,
                message: "只能输入10-20位 数字或26个英文字母",
                trigger: "change",
              },
            ]
          : [
              {
                required: true,
                message: "请输入纳税人识别码",
                trigger: "blur",
              },
              {
                pattern: /^[A-Za-z0-9]{10,20}$/,
                message: "只能输入10-20位 数字或26个英文字母",
                trigger: "change",
              },
            ];
    },
    changeInvoiceType2(index) {
      this.rules2.registAdress = [
        index == 1
          ? { required: true, message: "请输入单位地址", trigger: "blur" }
          : "",
      ];
      this.rules2.registPhone =
        index == 1
          ? [
              { required: true, message: "请输入电话", trigger: "blur" },
              { validator: this.phoneOrTelephone, trigger: "blur" },
            ]
          : [{ validator: this.phoneOrTelephone, trigger: "blur" }];
      this.rules2.openingBank = [
        index == 1
          ? { required: true, message: "请输入开户银行", trigger: "blur" }
          : "",
      ];
      this.rules2.bankAccount = [
        index == 1
          ? { required: true, message: "请输入银行账户", trigger: "blur" }
          : "",
      ];
      this.rules2.taxesNumber =
        index == 0 &&
        (this.ruleForm2.headType == 2 || this.ruleForm2.headType == 3)
          ? [
              {
                pattern: /^[A-Za-z0-9]{10,20}$/,
                message: "只能输入10-20位 数字或26个英文字母",
                trigger: "change",
              },
            ]
          : [
              {
                required: true,
                message: "请输入纳税人识别码",
                trigger: "blur",
              },
              {
                pattern: /^[A-Za-z0-9]{10,20}$/,
                message: "只能输入10-20位 数字或26个英文字母",
                trigger: "change",
              },
            ];
    },
    /**
     * 选择接收方式
     */
    changeAcceptType(index) {
      this.rules.pickName = [
        index == 1
          ? { required: true, message: "请输入收货人姓名", trigger: "blur" }
          : "",
      ];
      this.rules.pickPhone =
        index == 1
          ? [
              { required: true, message: "请输入收货人电话", trigger: "blur" },
              {
                pattern:
                  /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                message: "请输入正确的收货人电话",
                trigger: "blur",
              },
            ]
          : [
              {
                pattern:
                  /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                message: "请输入正确的收货人电话",
                trigger: "blur",
              },
            ];
      this.rules.sendAddress = [
        index == 1
          ? { required: true, message: "请输入寄送地址", trigger: "blur" }
          : "",
      ];
      if (index == 0) {
        this.ruleForm.invoiceType = 0;
      }
    },
    changeAcceptType2(index) {
      this.rules2.pickName = [
        index == 1
          ? { required: true, message: "请输入收货人姓名", trigger: "blur" }
          : "",
      ];
      this.rules2.pickPhone =
        index == 1
          ? [
              { required: true, message: "请输入收货人电话", trigger: "blur" },
              {
                pattern:
                  /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                message: "请输入正确的收货人电话",
                trigger: "blur",
              },
            ]
          : [
              {
                pattern:
                  /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                message: "请输入正确的收货人电话",
                trigger: "blur",
              },
            ];
      this.rules2.sendAddress = [
        index == 1
          ? { required: true, message: "请输入寄送地址", trigger: "blur" }
          : "",
      ];
      if (index == 0) {
        this.ruleForm2.invoiceType = 0;
      }
    },
    /**
     * 获取发票信息列表
     */
    getInfo() {
      var that = this;
      doGet(
        httpConfig.myInvoice.getInvoiceUrl,
        {
        },
        function (res) {
          if (res.flag) {
            that.invoiceInfoList = res.data;
          } else {
            // that.$message.warning(res.message);
          }
          that.isShowAddBtn = true;
        },
        function (res) {}
      );
    },
    /**
     * 获取开票列表
     */
    getList(val) {
      var data = {
        current: val,
        limit: this.limit,
      };
      var that = this;
      doGet(
        httpConfig.myInvoice.getInvoiceListUrl,
        data,
        function (res) {
          that.invoiceList = JSON.parse(JSON.stringify(res.data.rows));
          that.total = res.data.total;
          that.current = val;
        },
        function (res) {}
      );
    },
    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      //返回顶部
      this.getList(val);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    /**
     * 切换顶部导航栏
     */
    changeNav(index) {
      this.chooseIndex = index;
    },
    /**
     * 发票详情
     */
    gotoDetails2(id) {
      this.$router.push({ path: "/invoiceDetails", query: { id: id } });
    },
    /**
     * 商品详情
     */
    gotoDetails(id) {
      this.$router.push({ path: "/goodsInfo", query: { id: id } });
    },
    /**
     * 无效事件
     */
    nothing() {},

    /**
     * 点击新增发票信息
     */
    showDialog() {
      this.isShowArea = false;
      this.isShowArea2 = false;
      var t = setTimeout(() => {
        this.isShowArea = true;
        this.isShowArea2 = true;
      }, 0);
      this.dialogVisible = true;
    },
    /**
     * 关闭新增发票信息弹窗
     */
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.resetForm("ruleForm");
          done();
        })
        .catch((_) => {});
    },
    /**
     * 取消添新增发票信息
     */
    resetForm(formName) {
      this.isAgree = false;
      this.$refs[formName].resetFields();
      this[formName].isDefault = true;
      this.dialogVisible = false;
    },
    /**
     * 确认新增发票信息
     */
    submitForm(formName) {
      var that = this;
      // if (this.isAgree) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //固定电子发票
          that.ruleForm.acceptType = 0;
          var data = JSON.parse(JSON.stringify(that.ruleForm));
          data.isDefault = that.ruleForm.isDefault == true ? 1 : 0;
          doGet(
            httpConfig.myInvoice.editInvoiceUrl,
            data,
            function (res) {
              if (res.flag) {
                that.resetForm("ruleForm");
                that.getInfo();
                that.$message({
                  message: "新增成功",
                  type: "success",
                });
              } else {
                that.$message({
                  type: "error",
                  message: res.message,
                });
              }
            },
            function (res) {}
          );
        } else {
          return false;
        }
      });
      // } else {
      //   that.$message.warning("请阅读并同意开票资质确认书");
      // }
    },
    /**
     * 删除发票信息
     */
    deleteInvoice(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then((_) => {
          doGet(
            httpConfig.myInvoice.deleteInvoiceUrl,
            { id },
            function (res) {
              if (res.flag) {
                that.getInfo();
                that.$message({
                  message: "删除成功",
                  type: "success",
                });
              } else {
                that.$message({
                  type: "error",
                  message: res.message,
                });
              }
            },
            function (res) {}
          );
          done();
        })
        .catch((_) => {});
    },
    /**
     * 点击编辑发票信息
     */
    editDialog(index) {
      this.ruleForm2 = JSON.parse(JSON.stringify(this.invoiceInfoList[index]));
      this.ruleForm2.isDefault =
        this.invoiceInfoList[index].isDefault == 1 ? true : false;
      delete this.ruleForm2.createTime;
      delete this.ruleForm2.updateTime;
      this.judegRules();
      this.isAgree2 = true;
      this.dialogVisible2 = true;
    },
    /**
     * 关闭编辑发票信息弹窗
     */
    handleClose2(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.resetForm2("ruleForm2");
          done();
        })
        .catch((_) => {});
    },
    /**
     * 取消编辑发票信息
     */
    resetForm2(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible2 = false;
    },
    /**
     * 确认编辑发票信息
     */
    submitForm2(formName) {
      var that = this;
      // if (this.isAgree2) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //固定电子发票
          that.ruleForm2.acceptType = 0;
          var data = JSON.parse(JSON.stringify(that.ruleForm2));
          data.isDefault = that.ruleForm2.isDefault == true ? 1 : 0;
          doGet(
            httpConfig.myInvoice.editInvoiceUrl,
            data,
            function (res) {
              if (res.flag) {
                that.resetForm2("ruleForm2");
                that.getInfo();
                that.$message({
                  message: "编辑成功",
                  type: "success",
                });
              } else {
                that.$message({
                  type: "error",
                  message: res.message,
                });
              }
            },
            function (res) {}
          );
        } else {
          return false;
        }
      });
      // } else {
      //   that.$message.warning("请阅读并同意开票资质确认书");
      // }
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/personal/myInvoice";
</style>



// WEBPACK FOOTER //
// src/components/page/personal/myInvoice.vue